import { useState, useEffect } from 'react';

export default function Hero() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div 
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/3ad989e32a86778410e3d0b2bdfc5aba.jpg)'
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>

      {/* Navbar */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-lg' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <img 
            src="https://static.readdy.ai/image/26698e5f43d9efce92e955285c2ce22e/9e290fb29da60fa3221d2a96bd0f35fd.png" 
            alt="Logo Desafio 10 Dias" 
            className="h-12 w-auto cursor-pointer"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          />
          <div className="flex items-center gap-8">
            <button onClick={() => scrollToSection('como-funciona')} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${scrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'}`}>
              Como Funciona
            </button>
            <button onClick={() => scrollToSection('antes-depois')} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${scrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'}`}>
              Resultados
            </button>
            <button onClick={() => scrollToSection('vantagens')} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${scrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'}`}>
              Vantagens
            </button>
            <button onClick={() => scrollToSection('inscricao')} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${scrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'}`}>
              Inscrição
            </button>
            <button onClick={() => scrollToSection('contato')} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${scrolled ? 'text-gray-700 hover:text-teal-600' : 'text-white hover:text-teal-300'}`}>
              Contato
            </button>
          </div>
        </div>
      </nav>

      {/* Hero Content */}
      <div className="relative z-10 text-center px-6 w-full">
        <h1 className="text-7xl md:text-8xl font-black text-white mb-6 tracking-wider">
          DESAFIO 10 DIAS
        </h1>
        <p className="text-2xl md:text-3xl text-white font-light mb-12 leading-relaxed">
          Transforme seu corpo<br />Mude sua vida
        </p>
        <button 
          onClick={() => scrollToSection('inscricao')}
          className="group relative inline-flex items-center gap-4 bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white font-bold text-base px-10 py-5 rounded-full transition-all duration-300 transform hover:scale-105 shadow-2xl whitespace-nowrap cursor-pointer"
        >
          <span className="flex items-center justify-center w-10 h-10 bg-lime-400 rounded-full -ml-2">
            <i className="ri-calendar-check-line text-white text-lg"></i>
          </span>
          <span className="tracking-wide">INSCREVA-SE AGORA</span>
          <i className="ri-arrow-right-up-line text-xl"></i>
        </button>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10">
        <div className="animate-bounce">
          <i className="ri-arrow-down-line text-white text-3xl"></i>
        </div>
      </div>
    </section>
  );
}
